import { ASSET_TYPES } from "../../../enums/assetTypes.enum";
import { ATTRIBUTE_KEYS } from "../../../pages/customers/facade/customers-facade.service";
import { isNotNullOrUndefined } from "../../../shared/utils/utils";
import { Address } from "../../shared/address";
import { AtedBy, TenantRef, Timestamp } from "../../shared/refs";
import { CustomerCompact } from "./assetCompact";

export type AttributeKey = (typeof ATTRIBUTE_KEYS)[number];

type AdditionalCustomerAttributes = Partial<Record<AttributeKey, number | null>>;

export type EnrichedCustomer = CustomerCompact & AdditionalCustomerAttributes;

export interface CustomerDTO {
  id?: string | null;
  label: string;
  assetType?: string | null;
  tenant?: TenantRef;
  email?: string | null;
  phone?: string | null;
  mobilePhone?: string | null;
  predictiveMaintenance?: boolean | null;
  address?: Address;
  severity?: string | null;
  expectedEnergyLossPerYear?: number | null;
  expectedEnergyLossPerDay?: number | null;
  numberOfGateSystems?: number | null;
  numberOfBuildings?: number | null;
  numberOfLocations?: number | null;
  timestamp?: Timestamp;
  createdBy?: AtedBy;
  updatedBy?: AtedBy;
  notes?: string | null;
}

export class Customer {
  id?: string;
  label: string;
  email?: string;
  phone?: string;
  mobilePhone?: string;
  address?: Address;
  notes?: string;
  predictiveMaintenance?: boolean;
  numberOfLocations?: number;
  numberOfBuildings?: number;
  numberOfGateSystems?: number;
  expectedEnergyLossPerYear?: number;
  expectedEnergyLossPerDay?: number;
  public assetType: string;
  tenant?: TenantRef;

  constructor(customer: CustomerDTO) {
    if (customer.id) this.id = customer.id;
    this.label = customer.label;
    if (customer.tenant) this.tenant = customer.tenant;
    if (isNotNullOrUndefined(customer.email)) this.email = customer.email;
    if (isNotNullOrUndefined(customer.phone)) this.phone = customer.phone;
    if (isNotNullOrUndefined(customer.mobilePhone)) this.mobilePhone = customer.mobilePhone;
    // if (isNotNullOrUndefined(customer.predictiveMaintenance))
    this.predictiveMaintenance = true;
    if (customer.notes) this.notes = customer.notes;
    if (customer.address) this.address = customer.address;
    if (isNotNullOrUndefined(customer.numberOfLocations)) this.numberOfLocations = customer.numberOfLocations;
    if (isNotNullOrUndefined(customer.numberOfBuildings)) this.numberOfBuildings = customer.numberOfBuildings;
    if (isNotNullOrUndefined(customer.numberOfGateSystems)) this.numberOfGateSystems = customer.numberOfGateSystems;
    if (isNotNullOrUndefined(customer.expectedEnergyLossPerYear))
      this.expectedEnergyLossPerYear = customer.expectedEnergyLossPerYear;
    if (isNotNullOrUndefined(customer.expectedEnergyLossPerYear))
      this.expectedEnergyLossPerDay =
        customer.expectedEnergyLossPerYear !== undefined ? customer.expectedEnergyLossPerYear / 365 : undefined;
    this.assetType = ASSET_TYPES.CUSTOMER;
  }

  public set properties(customer: CustomerDTO) {
    this.label = customer.label;
    if (isNotNullOrUndefined(customer.email)) this.email = customer.email;
    if (isNotNullOrUndefined(customer.phone)) this.phone = customer.phone;
    if (isNotNullOrUndefined(customer.mobilePhone)) this.mobilePhone = customer.mobilePhone;
    // if (isNotNullOrUndefined(customer.predictiveMaintenance))
    //   this.predictiveMaintenance = customer.predictiveMaintenance;
    if (isNotNullOrUndefined(customer.notes)) this.notes = customer.notes;
    if (customer.address) this.address = customer.address;
  }

  public readonly directParentId = "";

  public get values(): CustomerDTO {
    const customer: CustomerDTO = {
      label: this.label,
      // tenant: this.tenant,
    };
    // if (this.id) {
    //   customer.id = this.id;
    // }
    if (this.address) {
      if (
        this.address.street &&
        this.address.number &&
        this.address.city &&
        this.address.country &&
        this.address.zipCode
      ) {
        customer.address = this.address;
        if (!this.address.street) {
          delete customer.address.street;
        }
        if (!this.address.number) {
          delete customer.address.number;
        }
        if (!this.address.city) {
          delete customer.address.city;
        }
        if (!this.address.country) {
          delete customer.address.country;
        }
        if (!this.address.zipCode) {
          delete customer.address.zipCode;
        }
      }
    }
    if (isNotNullOrUndefined(this.email)) {
      customer.email = this.email;
    }
    if (this.predictiveMaintenance !== undefined || this.predictiveMaintenance !== null) {
      customer.predictiveMaintenance = this.predictiveMaintenance;
    }
    if (isNotNullOrUndefined(this.phone)) {
      customer.phone = this.phone.toString();
    }
    if (isNotNullOrUndefined(this.mobilePhone)) {
      customer.mobilePhone = this.mobilePhone.toString();
    }
    if (isNotNullOrUndefined(this.notes)) {
      customer.notes = this.notes;
    }

    return customer;
  }
}
